<div [ngClass]="{'aside-holder' : exit}">
	<div [ngClass]="{'side-edit-mode-btn' : exit}">
		<div class="justify-content">
			<div class="flex-start" *ngIf="currentView && tabs?.length > 1">
				<rl-back-button (onClick)="back()"></rl-back-button>
			</div>
			<div class="flex-end" *ngIf="exit">
				<button type="button" (click)="exit()" class="btn btn-icon-only side-edit-mode-btn-close" rlFocusMe id="close-add-new-item" value="{{'sidebar.edit.close.btn' | translate}}" attr.aria-label="{{'sidebar.edit.close.btn' | translate}}" tabindex="0">
					<span>&#x2715;</span>
					<span class="sr-only">{{'general.close' | translate}}</span>
				</button>
			</div>
		</div>
	</div>
	<ng-container [ngSwitch]="currentView">
    	<rl-box-tabs class="justify-content flex-wrap" *ngSwitchDefault [tabs]="tabs" (onSelect)="selectTab($event)"></rl-box-tabs>
    	<rl-edit-form *ngSwitchCase="'resource'" [applyBeforeSave]="setSection" [formType]="data.type" [section]="data.section" (onCancel)="back()" (onClose)="exit()" (onAdd)="data.onAdd($event)">
			<!-- <ng-template [ngTemplateOutlet]="sectionSelect"></ng-template> -->
		</rl-edit-form>
		<rl-edit-form *ngSwitchCase="'file'" [applyBeforeSave]="setSection" [formType]="data.type" [fromFile]="true" [item]="{ section : data.section}" (onCancel)="back()" (onClose)="exit()" (onAdd)="data.onAdd($event)">
			<!-- <ng-template [ngTemplateOutlet]="sectionSelect"></ng-template> -->
		</rl-edit-form>
	</ng-container>
</div>
<ng-template #sectionSelect>
	<div class="section-block">
		<div class="section-block-inner">
			<div class="section-content">
				<div class="form-flex editable-content border-rows">
					<div class="form-flex-row">
						<div class="form-flex-label">
							<label for="sections-dropdown" class="control-label">{{'section' | translate}}:</label>
						</div>
						<div  class="form-flex-input">
							<select class="form-control in-field-focus" id="sections-dropdown" [(ngModel)]="sectionIndex" attr.aria-required="true" >
								<option *ngFor="let s of sectionsDropdown; let i = index" [value]="i">{{s.name}}</option>
							</select>
						</div>
					</div> 
				</div>
			</div>
		</div>
	</div>
</ng-template>